const colors = {
  transparent: 'transparent',
  label: '#C6C6C6',
  lightBorder: '#f1f4f6',
  inactiveField: '#f2f2f2',
  inactiveButton: '#b7dbdd',
  inactiveIcon: '#EBEBEB',
  primaryHover: '#7773D9',
  secondary: '#D50032',
  secondaryHover: '#EE2541',
  yellow: '#352FD9',
  yellowHover: '#352FD9',
  border: '#dadada',
  black: '#000000',
  white: '#ffffff',
  primary: '#352FD9',
  heading: '#1D1D1B',
  heading3: '#1D1D1B',
  quote: '#343d48',
  text: '#4E5865',
  lightText: '#fff',
  link: '#352FD9',
  banner: '#1D1D1B',
  darkBg: '#1D1D1B',
  lightBg: '#fbfafe',
};

export default colors;
